
'use client';

import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Button } from './ui/button';
import Link from 'next/link';

export const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = Cookies.get('cookie_consent');
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        Cookies.set('cookie_consent', 'true', { expires: 365 });
        setShowBanner(false);
    };
    
    if (!showBanner) {
        return null;
    }

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-muted text-foreground border-t shadow-lg">
            <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
                <p className="text-sm text-center md:text-left">
                    Utilizamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestro uso de cookies. Puedes consultar nuestra{' '}
                    <Link href="/politicas-cookies" className="underline hover:text-primary">
                        Política de Cookies
                    </Link>.
                </p>
                <div className="flex gap-2 w-full md:w-auto">
                    <Button onClick={handleAccept} size="sm" className="w-full md:w-auto">
                        Aceptar
                    </Button>
                </div>
            </div>
        </div>
    );
};
